define([
  'jquery',
  'postscribe',
], function($, postscribe) {

  function Formsync(config, fields) {
    this.config = config;
    this.$syncEl = null;

    var fieldMap = {};
    if (Array.isArray(fields)) {
      fields.forEach(function(field) {
        if (field.form_sync_field) {
          fieldMap[field.field_variable] = field.form_sync_field;
        }
      });
    } else if (fields && typeof fields === 'object') {
      fieldMap = JSON.parse(JSON.stringify(fields));
    }

    if (config.email_field) {
      fieldMap['email'] = config.email_field;
    }

    this.fieldMap = fieldMap;

    this.install = function(fields) {
      this.fields = fields;

      this.$syncEl = $('<div class="sumo-formsync" />');
      this.$syncEl.hide();
      this.$syncEl.appendTo(document.body);

      //this.$syncEl.html(this.config.extracted_snippet);
      postscribe(this.$syncEl.get(0), this.config.snippet);
    };

    this.remove = function() {
      if (!this.$syncEl) return;

      console.log('Removing form now');
      this.$syncEl.remove();
      this.$syncEl = null;
    };

    this.submit = function(attempt) {
      if (!this.$syncEl) return;

      console.log('Injected! ' + document.readyState);
      console.log(this.$syncEl.html());

      var $formEl = this.$syncEl.find('form');
      if (!$formEl.length) {
        // give it 500*20 = 10 seconds to load
        if (attempt === undefined || attempt < 20) {
          console.log('No form element, trying again (' + attempt + ')...');
          var self = this;
          window.setTimeout(function () {
            self.submit((attempt || 0) + 1);
          }, 500);
        }
        return;
      }

      $formEl.prop('novalidate', true);
      // remove all event handlers/garbage
      $formEl.replaceWith($formEl.clone(false));
      $formEl = this.$syncEl.find('form');
      var self = this;
      $formEl.on('submit', function() {
        window.setTimeout(function() {
          self.remove();
        }, 10*1000);
      });

      this.$fieldsEl = this.$syncEl.find('input, select');
      console.log('Found fields: ' + this.$fieldsEl.length);

      for (var field in this.fields) {
        if (field in this.fieldMap) {
          console.log('Setting ' + field + ' (' +  this.fieldMap[field] + ') to ' + this.fields[field].value);
          this.setFieldValue(this.fieldMap[field], this.fields[field].value);
        }
      }

      var $submitEl = $formEl.find('input[type="submit"]');
      if (!$submitEl.length) $submitEl = $formEl.find('button[type="submit"]');

      if ($submitEl.get(0)) {
        $submitEl.trigger('click');
      } else {
        $formEl.trigger('submit');
      }
    };

    this.setFieldValue = function(name, value) {
      var $fieldEl = this.$fieldsEl.filter(function() {
        return ($(this).attr('name') === name);
      });

      if ($fieldEl.is('input')) {
        var type = ($fieldEl.attr('type') || '').toLowerCase();

        switch (type) {
          // set value
          case 'email':
          case 'password':
          case 'text':
          case 'hidden':
            $fieldEl.val(value);
            break;

          // check all fields that match value
          case 'checkbox':
          case 'radio':
            $fieldEl.filter(function () {
              return ($(this).val().toLowerCase() === value.toLowerCase());
            }).prop('checked', true);
            break;
        }
      } else if ($fieldEl.is('select')) {
        $fieldEl.val(value);
      }
    };
  }

  return Formsync;
});
